import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook, Star, Clock, Car, Shield, Sparkles } from 'lucide-react';
import logo from './images/logo2.png'; // Update path as needed

const Footer = ({ isMobile }) => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Column 1 - About & Logo */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <img 
                src={logo} 
                alt="JP Auto Detailing" 
                className="h-16 mb-4"
              />
            </div>
            <p className="text-gray-400 text-sm mb-6">
              Premium mobile detailing service in Chicago and surrounding areas. 
              We bring professional car care directly to your location.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/jpdetailingservices/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>
          
          {/* Column 2 - Services with updated links */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-semibold mb-4 text-white">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Full Detailing</Link>
              </li>
              <li>
                <Link to="/services?tab=exterior" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Exterior Detailing</Link>
              </li>
              <li>
                <Link to="/services?tab=interior" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Interior Detailing</Link>
              </li>
              <li>
                <Link to="/ceramic-coating" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Ceramic Coating</Link>
              </li>
              <li>
                <Link to="/fleet-services" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Dealership & Fleet Services</Link>
              </li>
              <li>
                <Link to="/gift-cards" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Gift Cards</Link>
              </li>
            </ul>
          </div>
          
          {/* Column 3 - Contact Information */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-semibold mb-4 text-white">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Phone className="h-5 w-5 text-blue-400 mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white text-sm font-medium">Call or Text</p>
                  <a href="tel:+16307082674" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">(630) 708-2674</a>
                </div>
              </li>
              <li className="flex items-start">
                <Mail className="h-5 w-5 text-blue-400 mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white text-sm font-medium">Email Us</p>
                  <a href="mailto:bookings@jp-autodetailing.com" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">bookings@jp-autodetailing.com</a>
                </div>
              </li>
              <li className="flex items-start">
                <MapPin className="h-5 w-5 text-blue-400 mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white text-sm font-medium">Service Area</p>
                  <p className="text-gray-400 text-sm">Chicago & Surrounding Areas</p>
                </div>
              </li>
              <li className="flex items-start">
                <Clock className="h-5 w-5 text-blue-400 mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white text-sm font-medium">Hours</p>
                  <p className="text-gray-400 text-sm">Mon-Sat: 8am - 7pm</p>
                  <p className="text-gray-400 text-sm">Sunday: 9am - 5pm</p>
                </div>
              </li>
            </ul>
          </div>
          
          {/* Column 4 - Why Choose Us */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-semibold mb-4 text-white">Why Choose Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Car className="h-5 w-5 text-blue-400 mr-3 mt-0.5 flex-shrink-0" />
                <p className="text-gray-400 text-sm">Mobile Service - We Come to You</p>
              </li>
              <li className="flex items-start">
                <Star className="h-5 w-5 text-blue-400 mr-3 mt-0.5 flex-shrink-0" />
                <p className="text-gray-400 text-sm">5-Star Rated Professional Service</p>
              </li>
              <li className="flex items-start">
                <Sparkles className="h-5 w-5 text-blue-400 mr-3 mt-0.5 flex-shrink-0" />
                <p className="text-gray-400 text-sm">Premium Products & Techniques</p>
              </li>
              <li className="flex items-start">
                <Shield className="h-5 w-5 text-blue-400 mr-3 mt-0.5 flex-shrink-0" />
                <p className="text-gray-400 text-sm">100% Satisfaction Guarantee</p>
              </li>
            </ul>
            
            <div className="mt-6">
              <Link to="/estimate" className="inline-block">
                <button className="bg-blue-500 hover:bg-blue-600 text-white px-5 py-2 rounded-lg text-sm font-medium transition-all duration-300">
                  Get Free Estimate
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      {/* Copyright Bar */}
      <div className="bg-gray-950 py-4">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm">
          <p>&copy; {currentYear} JP Auto Detailing. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;